<template>
  <div class="login-page">
    <div class="nav-logo-container">
      <img class="login-logo" src="@/assets/images/brave_bites_new_logo.png" alt="Brave Bites Logo" />
      <h1 class="title">Brave Bites</h1>
      <p class="subtitle">Helping you face food, one bite at a time.</p>
    </div>

    <form class="login_form" @submit.prevent="authenticate">
      <label class="medium">Email</label>
      <input type="email" v-model="email" placeholder="example@example.com" required />
      <label class="medium">Password</label>
      <input type="password" v-model="password" placeholder="y0ur pAs3W0rd" required />
      <div class="button-row">
        <button type="submit" class="button primary">
          <span v-if="!loading">Login</span>
          <span v-if="loading" class="loader button-loader"></span>
        </button>
      </div>
      <p v-show="loginFailed" class="error-msg">Login failed</p>
    </form>
  </div>
</template>

<script lang="ts">
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default {
  setup() {

    const router = useRouter();
    const auth = getAuth();
    const store = useStore();

    const email = ref('');
    const password = ref('');
    const loading = ref(false);
    const loginFailed = ref(false);

    const authenticate = async () => {

      loading.value = true;

      try {

        const userCredential = await signInWithEmailAndPassword(auth, email.value, password.value);
        const user = userCredential.user;

        // Get the ID token
        const token = await user.getIdToken();

        // Save user + token in Vuex store
        store.commit('setUser', user);
        store.commit('setIdToken', token);

        // Redirect
        router.push('/');

      } catch (error) {

        loading.value = false;
        loginFailed.value = true;

      }
    };

    return {
      email,
      password,
      authenticate,
      loading,
      loginFailed,
    };
  },
};

</script>

<style scoped>

.nav-logo-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
}

.login-logo {
  width: 130px;
  height: auto;
}

.title {
  margin: 0;
  font-size: 2.5rem;
  font-weight: 600;
  color: #5aad8d;
}

.subtitle {
  padding-bottom: 30px;
  font-weight: 200;
}

@media (max-width: 430px) {
  .page-content {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.button-row > button {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: var(--space-md);
}

.login_form {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.login_form > label {
  margin-top: var(--space-md);
  color: rgb(38, 38, 38);
}

.error-msg {
  color: red;
  font-size: 0.8rem;
  text-align: center;
  margin-top: 10px;
}

.about-link {
  font-size: 14px;
  color: #a6917b;
  margin-top: 10px;
  display: block;
}

.about-link:hover {
  text-decoration: underline;
}

/* .login-page {
  border: 2px solid rgb(244, 244, 244);
  padding: var(--space-xl);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-elevation-medium)
} */
    
</style>
  